module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("I Think You’re Wrong (But I’m Listening)")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/9781400208425_template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "Part One: Start With You"
    }
  }, [_c('p', {
    staticClass: "part_no",
    attrs: {
      "id": "part1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvii",
      "title": "xvii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpart1"
    }
  }, [_vm._v("part one")])])]), _vm._v(" "), _c('p', {
    staticClass: "part_tit"
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpart1"
    }
  }, [_c('b', [_vm._v("START WITH YOU")])]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xviii",
      "title": "xviii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52ceeb07","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9781400208425_Part_1.vue
// module id = 81
// module chunks = 0